<template>
  <div class='report-item report-item--expanding-stat brand-background-color' :style='{backgroundColor: computedBackgroundColor}'>
    <div class="text">
      <div class='actions' v-if='editable && !this.config.stat'>
        <StatEditor @add='addStat($event)' :report='report' ></StatEditor>
      </div>
      <div class='stats-header' v-if='config.stat' :style='headingStyles'>
        <div class='stats-expander'>
          <div class="stats">
            <Stat :translated='$t(config.stat.text, "stat.text", this.tag)' :config='config.stat' @edit='onEditStat($event)' :circle='false' v-if='config.stat' :theme='theme' @delete='deleteStat' :editable='editable' :data='report.stats'></Stat>
            <div class='expander' v-if='config.stat && config.expandable' @click.prevent='toggleExpand'>
              <ion-icon name='remove' v-if='config.expanded'></ion-icon>
              <ion-icon name='add' v-if='!config.expanded'></ion-icon>
            </div>
          </div>
        </div>
      </div>
      <transition name='fade' mode='out-in'>
        <div :key='expanderID' class='expanded' :id='expanderID' v-show='config.expanded && currentReport'>
          <div :class="breakdownClasses" v-if='currentReport'>
            <QuestionBreakdown :translation-context='`${tag}.questionbreakdown`' @edit='onEditBreakdown($event)' :editable='editable' class='full-size' :circle='true' :config='questionBreakdownTheme' :data='currentReport'></QuestionBreakdown>
          </div>
        </div>
      </transition>
      <div class="extended-info" v-if='config.showCommentary && config.stat'>
        <div class="commentary-header" :style='{backgroundColor: computedCommentBackgroundColor}'>
          <ContentEditable :html='true' :style='{color: computedCommentTitleColor}' :font-scale='computedCommentTitleFontSize' tag='h2' :editable='editable' v-model='content.title' placeholder='Commentary title' :translated='$t(content.title, "extended.title",tag)'></ContentEditable>
        </div>

        <ContentEditable :style='{color: computedCommentTextColor}' :font-scale='computedCommentTextFontSize' :html='true' tag='div' :editable='editable' v-model='content.commentary' placeholder='Commentary text' :translated='$t(content.commentary, "extended.commentary",tag)'></ContentEditable>
        <Button v-if='content.cta.show' @change='onCTAChange($event)' @edit='onCTAEdit($event)' :editable='editable' :config='config.cta' :beforeText='$t(content.title, "cta.beforeText",tag)' :afterText='$t(content.title, "cta.afterText",tag)'></Button>
      </div>
    </div>
    <div v-if='editable'>
      <UIActions @add='onAdd' @delete='onDelete' @edit='onEdit'></UIActions>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import UIActions from './UIActions.vue'
import ContentEditable from '../../ContentEditable.vue'
import _ from 'lodash';
import Stat from './Stat'
import QuestionBreakdown from './QuestionBreakdown'
import StatEditor from '../../report-editor/components/StatEditor'
import Button from './Button.vue'
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: {
    config: {default: ()=>{{}}, type: Object},
    report: {default: ()=>({}), type: Object},
    response: {type: Object, default: ()=>{{}}},
    editable: {default: true, type: Boolean}
  },
  mixins: [TranslationMixin],
  data () {
    return {
      content: {},
      ready: false,
      newStat: null,
      currentReport: null,
      reports: null,
      stat: null,
      expanderID: null
    }
  },
  inject: ['globalTheme'],
  components: {
    UIActions,
    ContentEditable,
    StatEditor,
    Stat,
    QuestionBreakdown,
    Button
  },
  methods: {
    onEditStat (event) {
      this.$emit('edit', event)
    },
    toggleExpand () {
      this.config.expanded = !this.config.expanded
      if(this.config.expanded){
        Vue.nextTick(() => {
          let expanderElement = document.getElementById(this.expanderID);
          let y = expanderElement.offsetTop
          window.scrollTo({left:0, top: y, behavior: 'smooth'})
        })
      }
    },
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'ExpandingStatEditPanel'})
    },
    onCTAEdit (event) {
      this.$emit('edit', event)
    },
    onCTAChange (event) {
      this.content.cta = JSON.parse(JSON.stringify(event))
    },
    onAdd () {
      this.$emit('add')
    },
    onDelete () {
      this.$emit('delete')
    },
    onEditBreakdown (event) {
      this.$emit('edit', event)
    },
    addStat (event) {
      this.config.stat = event
      this.stat = this.config.stat
      this.currentReport = this.reports[event.question]
    },
    deleteStat (event) {
      let conf = confirm("Deletion is permanent. Are you sure?")
      if(conf){
        this.config.stat = null
        this.config.expanded = false
        this.currentReport = null
      } else {
        return
      }
    }
  },
  computed: {
    theme () {
      let themeOptions = {
        statColor: this.config.theme.statFigureColor
      }
      return {
        ...themeOptions,
        ...this.config.theme
      }
    },
    headingStyles () {
      return {
        color: this.theme.statHeadingColor,
        backgroundColor: this.theme.statBackgroundColor,
        backgroundImage: "url(" +this.config.image+ ")",
        backgroundPosition: '50% 50%',
        backgroundSize: 'cover'
      }
    },
    detailStyles () {
      return {
        color: this.theme.detailHeadingColor
      }
    },
    breakdownClasses () {
      let classes = ['question-breakdown-wrapper']
      if(this.config.showCommentary === true){
        classes.push('has-commentary')
      }
      return classes;
    },
    questionBreakdownTheme () {
      return {
        theme: this.theme
      }
    },
    computedBackgroundColor () {
      return this.config.theme.backgroundColor || this.globalTheme.brandColor
    },
    computedCommentTitleFontSize () {
      return this.config.theme.commentTitleFontSize || this.globalTheme.titleFontSize
    },
    computedCommentTextFontSize () {
      return this.config.theme.commentTextFontSize || this.globalTheme.textFontSize
    },
    computedCommentTextColor () {
      return this.config.theme.commentTextColor || this.globalTheme.brandTextColor
    },
    computedCommentTitleColor () {
      return this.config.theme.commentTitleColor || this.globalTheme.brandTitleColor
    },
    computedCommentBackgroundColor () {
      return this.config.theme.commentBackgroundColor || this.globalTheme.circleColor
    }
  },
  created () {
    this.content = this.config
    this.expanderID = 'expander-' + this._uid;
    let questions;
    if (!this.response) {
      questions = this.report.questions
    } else {
      questions = this.response.result.agreement.questions
    }
    let reports = {}
    for (let key in questions){
      let question = questions[key]
      reports[key] = {questionKey: key, question: this.report.questions[key], stats: this.report.stats[key], answers: this.report.answers[key]}
      if (this.response) {
        Object.assign(reports[key], question)
      }
    }
    this.reports = reports;
    if(this.config.stat) {
      this.currentReport = this.reports[this.config.stat.question]
    }

  },
  watch: {
    content: {
      handler: _.debounce(function(content){
        if (!this.editable) {
          return
        }
        if(!this.ready){
          this.ready = true
          return
        }
        this.$store.commit('setDirty', true)
        this.$store.dispatch('saveItem', content)
      }, 500),
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
  @import '../../../../scss/components/variables';
  @import '../scss/transitions';
  @import '../../../../scss/components/form';

  .fade-enter-active, .fade-leave-active {
    transition: all .5s linear;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
      overflow: hidden;
      max-height: 0;
  }

  .fade-enter-to, .fade-leave {
    max-height: 500px;
   overflow: hidden;
  }

  .simple-form {
    .extended-info {
      ::v-deep .content-editable--input[contenteditable='true'] {
        border-bottom: 2px dashed rgba(0,0,0,0.4);
      }
    }
  }
  .report-item--expanding-stat {
    background-size: cover;
    min-height: 150px;
    //height: 20vh;
    .stats-expander {
      width: 90%;
      margin:auto;
      padding: 0.75rem 0 40px 0;
      position: relative;
      .stats {
        padding: 0;
        @media (min-width: 768px){
          //padding: 0 1rem;
        }
      }
      @media(min-width: 768px) {
        width: 80%;
        padding: 0.75rem 0 80px 0;
      }
    }
    .extended-info {
      margin:2rem  auto;
      width: 90%;
      @media (min-width: 758px){
        width: 80%;
        margin: 3rem auto;
      }
    }
    .commentary-header {
      margin-bottom: 2rem;
      background-color: #fbd147;
      padding: 1rem 1rem;
      border-radius: 10px;
      ::v-deep h2.content-editable--input {
        margin-bottom: 0;
        //font-size: 130%;
      }
      @media (min-width: 768px) {
        padding: 1.3rem 2rem;
        ::v-deep h2.content-editable--input {
          //font-size: 160%;
        }
      }
    }
    .stats {
      padding: 0 1rem;
      .stat + .stat {
        border-top: 2px solid #000;
      }
      @media (min-width: 768px) {
        margin-top: 1rem;
        padding: 0.75rem 1rem 0.25rem 1rem;
      }
    }
    .actions {
      width: 80%;
      margin: 2rem auto;
    }

    .expander {
      display: flex;
      cursor: pointer;
      position: absolute;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      bottom: 0;
      left:0;
      right: 0;
      width: 75px;
      height: 40px;
      margin: auto;
      text-align:center;
      background-color: white;
      border-radius: 100px 100px 0 0;
      ion-icon {
        margin-top: 6px;
        color: black;
        font-size: 25px;
      }
      @media (min-width: 768px){
        width: 150px;
        height: 75px;
        border-radius: 150px 150px 0 0;
        ion-icon {
          margin-top: 10px;
          font-size: 45px;
        }
      }
    }
    ::v-deep .stat {
      @media (min-width: 920px){
        padding: 4rem 0;
      }
      .figure {
        @media (min-width: 768px) {
          .figure-content {
            h2 {
              //font-size: 10vw;
            }
          }
        }
        @media (min-width: 1000px) {
          .figure-content {
            h2 {
              //font-size: 8vw;
            }
          }
        }
        @media (min-width: 1200px) {
          .figure-content {
            h2 {
              //font-size: 8vw;
            }
          }
        }
        @media (min-width: 1300px) {
          .figure-content {
            h2 {
              //font-size: 6rem;
            }
          }
        }
      }
      .caption {
        text-align: center;
        @media (min-width: 768px) {
          text-align: left;
        }
        @media (min-width: 768px){
          padding-left: 2rem;
        }
        font-size: 150%;
        line-height: 1.3;
        font-size: 100%;
        @media (min-width: 768px) {
          //font-size: 300%;
        }
      }
      .ui-actions {
        top: 30px;
      }
    }

    ::v-deep .stat.without-value {
      .caption {
        @media (min-width: 768px){
          padding-left: 0rem;
        }
      }
    }

    ::v-deep .question-breakdown-wrapper {
      //background-color: white;
      padding: 5% 0 ;
      &.has-commentary {
        padding-bottom: 0;
      }
      .bars {
        margin-bottom:0;
        padding-bottom: 0;
      }
      .question {
        margin-bottom: 0;
        & + .question {
          margin-top: 2rem;
        }
      }
    }
    .question-breakdown {
      width: 90%;
      ::v-deep hr {
        //margin-bottom: 1rem;
      }
      @media (min-width: 758px){
        width: 80%;
      }
      margin:auto;
    }
    @media(min-width: 768px) {
      //min-height: 300px;
      // height: 30vh;
    }
    @media(min-width: 920px) {
      //min-height: 400px;
      // height: 45vh;
    }
    .text {
      display: flex;
      height:100%;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      margin:auto;
      h1 {
        margin-bottom: 0.1rem;
      }
      h2 {
        margin-top: 0;
      }
    }
  }
</style>